// extracted by mini-css-extract-plugin
export var price = "style-module--price--f5fb4";
export var totals = "style-module--totals--fd36f";